import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ldc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Only redirect if we're on a protected route
      const path = window.location.pathname;
      if (path.startsWith("/dashboard") || path.startsWith("/customer") || path.startsWith("/settings")) {
        localStorage.removeItem("ldc_token");
        localStorage.removeItem("ldc_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
